export default () => {
    // FrontPage 
    const arrowDow = document.querySelector('.js-scrollTo');
    const headerSite = document.querySelector('.Header');
    if(arrowDow){
      arrowDow.addEventListener('click', () => {
        scroll(0,window.innerHeight-headerSite.offsetHeight+16);
      })
    }

}